export const removeWhitespace = (string: string) => {
  const whitespaceReg = /\s/g;
  return string.replace(whitespaceReg, '');
};
